import React from 'react';
import './Alert.scss';

export type AlertType = 'success' | 'error' | 'info';

interface Props {
  children: React.ReactNode | React.ReactNode[];
  type?: AlertType;
}

function Alert({ children, type }: Props) {
  const alertClass = type ? `alert alert__${type}` : 'alert';

  const screenReaderOnlyMessage = () => {
    switch (type) {
      case 'success':
        return 'Success: ';
      case 'info':
        return 'Information: ';
      case 'error':
      default:
        return 'Error: ';
    }
  };

  if (children) {
    return (
      <div aria-live="assertive" className={alertClass} role="alert" aria-atomic="true">
        <span className="sr-only">{screenReaderOnlyMessage()}</span>
        {children}
      </div>
    );
  }
  return null;
}

export default React.memo(Alert);
